/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _moment from 'moment';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import dayjs from 'dayjs';

const moment = _moment;

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
  selectedFromDate: any;
  selectedToDate: any;
  dateFormat = this.utilityService.dateFormat;
  dateFilter: {
    'from_date': string;
    'to_date': string;
  } = {
    'from_date' : moment().format(this.dateFormat),
    'to_date' : moment().format(this.dateFormat)
  };
  allowMaxDate: boolean = true;
  maxDate: any;
  maxLimitCount: number = 3;
  maxLimitUnit: any = 'months';
  allUnits: any = {
    'days': this.utilityService.getLocaleValue('day(s)'),
    'months': this.utilityService.getLocaleValue('month(s)'),
    'years': this.utilityService.getLocaleValue('year(s)')
  };

  constructor(
    public matDialogRef: MatDialogRef<DateRangeComponent>,
    private utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  getFromDate(): void{
    if(this.selectedFromDate && moment(this.selectedFromDate).isBefore(moment(this.selectedToDate))){
      this.dateFilter['from_date'] = moment(this.selectedFromDate).format(this.dateFormat);
    }else{
      this.selectedToDate = null;
      this.dateFilter['from_date'] = moment(this.selectedFromDate).format(this.dateFormat);
      this.dateFilter['to_date'] = '';
    }
    this.updateMaxDate();
  }

  getToDate(): void {
    if(this.selectedToDate){
      this.dateFilter['to_date'] = moment(this.selectedToDate).format(this.dateFormat);
    }else{
      this.dateFilter['to_date'] = '';
    }
  }

  applyFilter(): void{
    const dateRange = {
      'result': true,
      'key': 'CUSTOM_RANGE',
      'startDate': dayjs(this.dateFilter.from_date,this.dateFormat).format('YYYY-MM-DD'),
      'endDate': dayjs(this.dateFilter.to_date,this.dateFormat).format('YYYY-MM-DD')
    };
    this.matDialogRef.close({result: true,dateRange: dateRange});
  }

  closeModal(): void{
    this.matDialogRef.close({result: false,dateRange: {}});
  }

  ngOnInit(): void {
    if(this.data?.data?.startDate && this.data?.data?.endDate){
      this.selectedFromDate = moment(this.data?.data?.startDate);
      this.dateFilter['from_date'] = moment(this.selectedFromDate).format(this.dateFormat);
      this.selectedToDate = moment(this.data?.data?.endDate);
      this.dateFilter['to_date'] = moment(this.selectedToDate).format(this.dateFormat);
    }else{
      this.selectedFromDate = moment();
      this.selectedToDate = moment();
    }
    if(!this.data.data.allowMaxDate){
      this.allowMaxDate = false;
    }
    if(this.data.data.maxLimitCount){
      this.maxLimitCount = this.data.data.maxLimitCount;
    }
    else{
      this.maxLimitCount = 3;
    }
    if(this.data.data.maxLimitUnit){
      this.maxLimitUnit = this.data.data.maxLimitUnit;
    }
    else{
      this.maxLimitUnit = 'months';
    }
    this.updateMaxDate();
  }

  updateMaxDate(): void {
    this.maxDate = moment(this.selectedFromDate).add(this.maxLimitCount, this.maxLimitUnit).subtract(1,'d');
    if (moment(this.selectedToDate).isAfter(this.maxDate)) {
      this.selectedToDate = this.maxDate;
      this.dateFilter['to_date'] = moment(this.maxDate).format(this.dateFormat);
    }
  }
}
